export default {
  latitude: 29.5,
  longitude: -84.2,
  latitudeDelta: 5,
  longitudeDelta: 5,
};
